































































































































































































import {Component, Vue, Watch} from "vue-property-decorator"
import store from "./../store"
import {adminApiService} from "./../services/admin-api"
import EventBus from "./../eventBus"
import moment from "moment"
import {systemSrv} from "../services/system"
import router from "@/router"

@Component({
  components: {},
})
export default class JobVacancyView extends Vue {
  params
  newItemDefault = {salary: {}, contact: {}, hours: {}, mall: {}, noOfPositions: 1}
  categories: any = []
  jobMatches: any = {
    docs: [],
    total: 0,
  }
  data: any = {
    id: null,
    categories: [],
    edit: false,
    dates: [],
    tabInputs: [
      {name: "responsibilities", label: "Responsibilities", note: ""},
      {name: "qualifications", label: "Skills/Qualifications", note: ""},
      //{name: "skills", label: "Skills", note: ""},
      //{name: "experience", label: "Experience", note: ""},
      //{name: "education", label: "Education", note: ""},
      {name: "benefits", label: "Perks and Benefits", note: ""},
    ],
    minDate: moment().format("YYYY-MM-DD"),
    startDatePicker: false,
    endDatePicker: false,
    item: this.newItemDefault,
    bottomSheet: false,
    bottomSheetRequest: "",
    extendVacancyModal: false,
  }
  constructor() {
    super()
  }
  beforeRouteUpdate(to, from, next) {
    this.params = to.params
    this.init()
    next()
  }
  created() {
    this.params = this.$route.params
    this.init()
  }
  mounted() {
    let profile: any = systemSrv.getProfile()
    console.log("PROF", profile)
    if (!profile.jobApplyConnect || ((!profile.jobApplyConnect.email || profile.jobApplyConnect.email == "") && (!profile.jobApplyConnect.phone || profile.jobApplyConnect.phone == "") && (!profile.jobApplyConnect.url || profile.jobApplyConnect.url == ""))) {
      console.log("BLOCK - MISSING CRUCIAL DATA")
      EventBus.$emit("snack", {type: "error", text: "Please complete required Settings before creating job post"})
      router.push({name: "settings"}).catch((err) => {
        console.log("error routing", err)
      })
      return false
    }
  }

  filterCategory(item, q, text) {
    console.log("filterCategory", q)
    const textOne = item.name.toLowerCase()
    //const textTwo = item.abbr.toLowerCase()
    const searchText = q.toLowerCase()

    return textOne.indexOf(searchText) > -1 // || textTwo.indexOf(searchText) > -1
  }
  async init() {
    console.log("Initialisation of componentn", this.params)
    this.data.id = this.params["id"]
    if (this.data.id == "0") {
      this.prepareNew()
    } else {
      this.load()
    }
    this.categories = await adminApiService.loadCategories({q: this.data.categoryFilter})
    this.data.categories = this.categories
  }
  prepareNew() {
    console.log("preparing new job")
    this.data.item = Object.assign(
      {},
      this.newItemDefault,
      {_id: this.data.id},
      {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment()
          .add(1, "months")
          .format("YYYY-MM-DD"),
      }
    )
    this.data.edit = true
  }
  back() {
    this.$router.back()
  }
  edit() {
    this.data.edit = !this.data.edit
  }
  async save() {
    if (!this.data.item.title) {
      EventBus.$emit("snack", {type: "error", text: "Title is required field"})
      return
    }
    if (!this.data.item.category) {
      EventBus.$emit("snack", {type: "error", text: "Category is required field"})
      return
    }
    if (!this.data.item.type) {
      EventBus.$emit("snack", {type: "error", text: "Employment type is required field"})
      return
    }
    if (!this.data.item.responsibilities) {
      EventBus.$emit("snack", {type: "error", text: "Job Responsibilities field is required"})
      return
    }

    this.momentifyDatePickerFormat()
    let result = await adminApiService.saveJobVacancy(this.data.item._id, this.data.item)
    if (result && result.error == true) {
      EventBus.$emit("snack", {type: "error", text: "Error creating job", subtext: result.message})
      return
    }
    if (result) {
      if (this.data.id == "0") {
        this.$router.replace({name: "jobVacancyView", params: {id: result._id}}).catch((err) => {})
      }
      this.data.item = Object.assign({}, this.newItemDefault, result)
      this.fixDatePickerFormat()
      this.data.edit = false
      EventBus.$emit("snack", {type: "info", text: "Saved"})
    }
  }
  fixDatePickerFormat() {
    this.data.item.startDate = moment(this.data.item.startDate).format("YYYY-MM-DD")
    this.data.item.endDate = moment(this.data.item.endDate).format("YYYY-MM-DD")
  }
  momentifyDatePickerFormat() {
    this.data.item.startDate = moment(this.data.item.startDate).toISOString()
    this.data.item.endDate = moment(this.data.item.endDate).toISOString()
  }
  async confirmArchive() {
    let result = await adminApiService.archiveJobVacancy(this.data.id)
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error archiving tenant", subtext: result.message})
      return
    }
    if (result) {
      Vue.set(this.data, "item", Object.assign({}, this.newItemDefault, result)) //this.data.item =
      this.fixDatePickerFormat()
      this.data.bottomSheet = false
      EventBus.$emit("snack", {text: "Tenant has been archived"})
    }
  }
  async confirmRequestApproval() {
    let result = await adminApiService.requestApprovalJobVacancy(this.data.id)
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error activating tenant", subtext: result.message})
      return
    }
    if (result) {
      this.data.item = Object.assign({}, this.newItemDefault, result)
      this.fixDatePickerFormat()
      this.data.bottomSheet = false
      EventBus.$emit("snack", {text: "Tenant request for approval successful"})
    }
  }
  extendVacancy() {
    this.data.extendVacancyModal = true
  }
  async confirmExtendVacancy() {
    let result = await adminApiService.confirmExtendVacancy(this.data.id, this.data.item)
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error extending the job post", subtext: result.message})
      return
    }
    if (result) {
      this.data.item = Object.assign({}, this.newItemDefault, result)
      this.fixDatePickerFormat()
      this.data.extendVacancyModal = false
      EventBus.$emit("snack", {text: "Job Post has been Approved and Extended. (No approval required)"})
    }
  }
  archive() {
    this.data.bottomSheet = true
    this.data.bottomSheetRequest = "ARCHIVE"
  }
  publish() {
    this.data.bottomSheet = true
    this.data.bottomSheetRequest = "PUBLISH"
  }
  async load() {
    let result = await adminApiService.loadJobVacancy(this.data.id)
    if (result && result.error == true) {
      EventBus.$emit("notification", {type: "error", text: "Error loading tenant", subtext: result.message})
      return
    }
    if (result) {
      this.data.item = Object.assign({}, this.newItemDefault, result)
      this.fixDatePickerFormat()

      this.loadMatchingJobs(this.data.item)
    }
  }
  async loadMatchingJobs(jobVanacy) {
    console.log("jobVanacy", jobVanacy)
    let malls = jobVanacy.mall ? [jobVanacy.mall.slug] : []
    let categories = [jobVanacy.category]
    let types = [jobVanacy.type]
    let payload = {
      malls,
      categories,
      types,
    }
    let result = await adminApiService.loadMatchingJobSeekers(payload)
    if (result && result.error == true) {
    } else {
      this.jobMatches = result
    }
  }
  viewJobSeeker(item) {
    this.$router.push({name: "jobSeekersView", params: {id: item._id}})
  }
}
